<div class="page-wrapper" *ngIf="customer">
  <div class="search-box">
    <div class="form-control">
      <div class="icon">
        <img src="/assets/img/icons/search.svg" alt="search" />
      </div>
      <input
        type="text"
        placeholder="Search..."
        (input)="searchShipper()"
        [(ngModel)]="searchString"
      />
    </div>
    <div class="display-options">
      <div
        class="disp-btn display-all"
        [ngClass]="{ 'active-disp-btn': checkDisplaySelection() }"
        (click)="selectColumns()"
      >
        Display All
      </div>
      <div
        class="disp-btn display-filters"
        [ngClass]="{ 'active-disp-btn': !checkDisplaySelection() }"
        [matMenuTriggerFor]="filterOptions"
      >
        <div class="btn-title">
          <span>Display</span>
          <mat-icon>expand_more</mat-icon>
        </div>
        <mat-menu #filterOptions="matMenu">
          <div class="filter-options">
            <div
              class="f-option"
              *ngFor="let col of tableFilterColumns; let i = index"
            >
              <mat-checkbox
                (click)="$event.stopPropagation()"
                [disabled]="lastColumnIndex === i"
                [(ngModel)]="columnsStates[i]"
                (change)="selectColumns(i)"
                >{{ col }}</mat-checkbox
              >
            </div>
          </div>
        </mat-menu>
      </div>
    </div>
    <button mat-button class="add-btn" (click)="toggleShipperModal()">
      Add New Shipper
    </button>
  </div>

  <div class="table-box">
    <table
      mat-table
      [dataSource]="dataSource"
      class="data-table shippers-table"
    >
      <ng-container matColumnDef="company">
        <th
          mat-header-cell
          class="sortable-header"
          *matHeaderCellDef
          (click)="sortShippers('name')"
        >
          <div class="table-header-wrapper">
            COMPANY
            <div class="sort-controls" *ngIf="selectedSort.field === 'name'">
              <img
                src="/assets/img/icons/sort_arrow_up.svg"
                alt="up"
                *ngIf="selectedSort.mode !== 'desc'"
              />
              <img
                src="/assets/img/icons/sort_arrow_down.svg"
                alt="down"
                *ngIf="selectedSort.mode !== 'asc'"
              />
            </div>
            <div class="sort-controls" *ngIf="selectedSort.field !== 'name'">
              <img src="/assets/img/icons/sort_arrow_up.svg" alt="up" />
              <img src="/assets/img/icons/sort_arrow_down.svg" alt="down" />
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let shipper"
          class="customer-name"
          (click)="selectShipper(shipper); toggleShipperModal()"
        >
          <div class="company-info" [title]="shipper.name">
            {{ shipper.name }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="person">
        <th
          mat-header-cell
          class="sortable-header"
          *matHeaderCellDef
          (click)="sortShippers('lastName')"
        >
          <div class="table-header-wrapper">
            PERSON
            <div
              class="sort-controls"
              *ngIf="selectedSort.field === 'lastName'"
            >
              <img
                src="/assets/img/icons/sort_arrow_up.svg"
                alt="up"
                *ngIf="selectedSort.mode !== 'desc'"
              />
              <img
                src="/assets/img/icons/sort_arrow_down.svg"
                alt="down"
                *ngIf="selectedSort.mode !== 'asc'"
              />
            </div>
            <div
              class="sort-controls"
              *ngIf="selectedSort.field !== 'lastName'"
            >
              <img src="/assets/img/icons/sort_arrow_up.svg" alt="up" />
              <img src="/assets/img/icons/sort_arrow_down.svg" alt="down" />
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let shipper"
          class="users"
          (click)="selectShipper(shipper); toggleShipperModal()"
        >
          <div class="user-name">
            {{ shipper.firstName }} {{ shipper.lastName }}
          </div>
          <div class="user-email">
            {{ shipper.email }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="phone">
        <th
          mat-header-cell
          class="sortable-header"
          *matHeaderCellDef
          (click)="sortShippers('phone')"
        >
          <div class="table-header-wrapper">
            PHONE
            <div class="sort-controls" *ngIf="selectedSort.field === 'phone'">
              <img
                src="/assets/img/icons/sort_arrow_up.svg"
                alt="up"
                *ngIf="selectedSort.mode !== 'desc'"
              />
              <img
                src="/assets/img/icons/sort_arrow_down.svg"
                alt="down"
                *ngIf="selectedSort.mode !== 'asc'"
              />
            </div>
            <div class="sort-controls" *ngIf="selectedSort.field !== 'phone'">
              <img src="/assets/img/icons/sort_arrow_up.svg" alt="up" />
              <img src="/assets/img/icons/sort_arrow_down.svg" alt="down" />
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let shipper"
          class="shipper-phone"
          (click)="selectShipper(shipper); toggleShipperModal()"
        >
          <div class="phone">
            {{ shipper.phone }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="destination country">
        <th
          mat-header-cell
          class="sortable-header"
          *matHeaderCellDef
          (click)="sortShippers('country.name')"
        >
          <div class="table-header-wrapper">
            DESTINATION COUNTRY
            <div
              class="sort-controls"
              *ngIf="selectedSort.field === 'country.name'"
            >
              <img
                src="/assets/img/icons/sort_arrow_up.svg"
                alt="up"
                *ngIf="selectedSort.mode !== 'desc'"
              />
              <img
                src="/assets/img/icons/sort_arrow_down.svg"
                alt="down"
                *ngIf="selectedSort.mode !== 'asc'"
              />
            </div>
            <div
              class="sort-controls"
              *ngIf="selectedSort.field !== 'country.name'"
            >
              <img src="/assets/img/icons/sort_arrow_up.svg" alt="up" />
              <img src="/assets/img/icons/sort_arrow_down.svg" alt="down" />
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let shipper"
          class="dest-country"
          (click)="selectShipper(shipper); toggleShipperModal()"
        >
          {{ shipper.countryId.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="destination address">
        <th
          mat-header-cell
          class="sortable-header"
          *matHeaderCellDef
          (click)="sortShippers('address')"
        >
          <div class="table-header-wrapper">
            DESTINATION ADDRESS
            <div class="sort-controls" *ngIf="selectedSort.field === 'address'">
              <img
                src="/assets/img/icons/sort_arrow_up.svg"
                alt="up"
                *ngIf="selectedSort.mode !== 'desc'"
              />
              <img
                src="/assets/img/icons/sort_arrow_down.svg"
                alt="down"
                *ngIf="selectedSort.mode !== 'asc'"
              />
            </div>
            <div class="sort-controls" *ngIf="selectedSort.field !== 'address'">
              <img src="/assets/img/icons/sort_arrow_up.svg" alt="up" />
              <img src="/assets/img/icons/sort_arrow_down.svg" alt="down" />
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let shipper"
          class="dest-address"
          (click)="selectShipper(shipper); toggleShipperModal()"
        >
          {{ shipper.address }}
        </td>
      </ng-container>

      <ng-container matColumnDef="total">
        <th
          mat-header-cell
          class="sortable-header"
          *matHeaderCellDef
          (click)="sortShippers('countOfOrders')"
        >
          <div class="table-header-wrapper">
            TOTAL
            <div
              class="sort-controls"
              *ngIf="selectedSort.field === 'countOfOrders'"
            >
              <img
                src="/assets/img/icons/sort_arrow_up.svg"
                alt="up"
                *ngIf="selectedSort.mode !== 'desc'"
              />
              <img
                src="/assets/img/icons/sort_arrow_down.svg"
                alt="down"
                *ngIf="selectedSort.mode !== 'asc'"
              />
            </div>
            <div
              class="sort-controls"
              *ngIf="selectedSort.field !== 'countOfOrders'"
            >
              <img src="/assets/img/icons/sort_arrow_up.svg" alt="up" />
              <img src="/assets/img/icons/sort_arrow_down.svg" alt="down" />
            </div>
          </div>
        </th>
        <td mat-cell *matCellDef="let shipper" class="total">
          <div
            class="count-of-orders"
            [matMenuTriggerFor]="ordersList"
            #tableTrigger="matMenuTrigger"
          >
            {{ shipper.countOfOrders }}
          </div>
          <div class="orders-list">
            <mat-menu #ordersList="matMenu">
              <app-shipper-orders-modal
                *ngIf="tableTrigger.menuOpen"
                (click)="$event.stopPropagation()"
                [shipperId]="shipper.id ?? ''"
              ></app-shipper-orders-modal>
            </mat-menu>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>

      <tr class="mat-row no-data-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" colspan="7">
          No data matching the filter
        </td>
      </tr>
    </table>
  </div>
  <app-paginator
    [records]="paginationData"
    (pageSettings)="getPageSettings($event)"
  ></app-paginator>
</div>

<app-edit-shipper
  [shipperForEditId]="selectedShipper?.id"
  [companyId]="customer.id"
  (modalState)="toggleShipperModal(); updateState($event)"
  *ngIf="isNewShipper"
></app-edit-shipper>
